import { Card, Col, Container, Row, Table } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'

const SLotLocationWorkOrderPlan = () => {
  const { state } = useLocation()

  const headerTitleStyle = {
    color: 'var(--primary-orange)',
    fontSize: '24px',
    fontWeight: '600'
  }

  const cardStyle = {
    border: 'none',
    boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
    borderRadius: '12px',
    padding: '1.5rem',
    marginBottom: '1.5rem',
    backgroundColor: '#fff'
  }

  const tableHeaderStyle = {
    fontSize: '14px',
    fontWeight: '600',
    color: '#333333',
    letterSpacing: '0.5px',
    backgroundColor: '#f8f9fa',
    borderBottom: '2px solid #e9ecef'
  }

  return (
    <Container>
      <div className="d-flex align-items-center justify-content-between mt-3 mb-3">
        <div>
          <h4 style={headerTitleStyle}>Slot Location</h4>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              {state?.type && (
                <>
                  <li className="breadcrumb-item sj-item">
                    <Link
                      to={`/workorder/${state?.type}/detail/${state?.code}`}
                      replace={true}
                      state={state}
                      className="text-decoration-none"
                    >
                      <span className="text-muted">CREATE JOB MANUFACTURE</span>
                    </Link>
                  </li>
                </>
              )}
              {!state?.type && (
                <>
                  <li className="breadcrumb-item sj-item">
                    <Link
                      to={'/workorder/plan'}
                      className="text-decoration-none"
                    >
                      <span className="text-muted">WORK ORDER PLAN</span>
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link
                      to={`/workorder/plan/detail/${state?.id}`}
                      className="text-decoration-none"
                    >
                      <span className="text-muted">{state?.code}</span>
                    </Link>
                  </li>
                </>
              )}
              <li
                className="breadcrumb-item sj-item active fw-bold"
                aria-current="page"
                style={{ color: 'var(--primary-orange)' }}
              >
                SLOT LOCATION
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <Card style={cardStyle}>
        <div className="d-flex flex-row justify-content-between mb-3">
          <h5 className="fw-bold text-uppercase" style={{ color: '#333' }}>
            List Item
          </h5>
          <h6 className="fw-bold text-uppercase mt-1 me-4 text-secondary">
            {!state?.type && (
              <>
                <span className="text-success">{state.location.need_pack}</span>
                <span> / </span>
                <span className="fw-bold text-dark">
                  {state?.location?.available_pack} Pack
                </span>
              </>
            )}
            {state?.type && (
              <>
                {state?.location?.locations?.length > 0 && (
                  <>
                    <span className="text-success">
                      {state?.location?.locations?.reduce(
                        (acc, cur) => acc + cur.need_qty,
                        0
                      )}
                    </span>
                    <span> / </span>
                    <span className="fw-bold text-dark">
                      {state?.location?.locations?.reduce(
                        (acc, cur) => acc + cur.available_qty,
                        0
                      )}{' '}
                      Pack
                    </span>
                  </>
                )}
              </>
            )}
          </h6>
        </div>
        <Row>
          <Col md={12}>
            <Table hover responsive style={{ fontSize: '12px' }}>
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    No
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Item
                  </th>
                  <th
                    className="p-2 align-middle text-center"
                    style={tableHeaderStyle}
                  >
                    Item Alias
                  </th>
                  <th
                    className="p-2 align-middle text-center"
                    style={{ ...tableHeaderStyle, width: '15%' }}
                  >
                    Item Code
                  </th>
                  <th
                    className="p-2 align-middle text-center"
                    style={tableHeaderStyle}
                  >
                    Batch
                  </th>
                  <th
                    className="p-2 align-middle text-center"
                    style={tableHeaderStyle}
                  >
                    Total Pack
                  </th>
                  <th
                    className="p-2 align-middle text-end"
                    style={tableHeaderStyle}
                  >
                    Slot
                  </th>
                </tr>
              </thead>
              <tbody>
                {!state?.type &&
                  state.location.slots?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className="p-2 align-middle">{index + 1}</td>
                        <td className="p-2 align-middle">{item?.item_name}</td>
                        <td className="p-2 align-middle text-center">
                          {item?.item_alias}
                        </td>
                        <td className="p-2 align-middle text-center">
                          {item?.item_code}
                        </td>
                        <td className="p-2 align-middle text-center">
                          {item?.batch}
                        </td>
                        <td className="p-2 align-middle text-center">
                          {item?.total_pack} {item?.uom_pack}
                        </td>
                        <td className="p-2 align-middle text-end text-primary fw-bold">
                          {item?.slot_location}
                        </td>
                      </tr>
                    )
                  })}
                {state?.type &&
                  state?.location?.locations?.length > 0 &&
                  state?.location?.locations
                    ?.reduce((acc, cur) => {
                      return cur.items
                    }, [])
                    .map((item, index) => {
                      return (
                        <tr key={index}>
                          <td className="p-2 align-middle">{index + 1}</td>
                          <td className="p-2 align-middle">
                            {item?.item_name}
                          </td>
                          <td className="p-2 align-middle text-center">
                            {item?.item_alias || '-'}
                          </td>
                          <td className="p-2 align-middle text-center">
                            {item?.item_code}
                          </td>
                          <td className="p-2 align-middle text-center">
                            {item?.batch}
                          </td>
                          <td className="p-2 align-middle text-center">
                            {item?.qty ? `${item?.qty} ${item?.uom_pack}` : '-'}
                          </td>
                          <td className="p-2 align-middle text-end text-primary fw-bold">
                            {item?.location}
                          </td>
                        </tr>
                      )
                    })}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Card>
    </Container>
  )
}

export default SLotLocationWorkOrderPlan
